import React, { useState, useEffect } from "react";
import ViewTable from "../../commonComponents/ViewTable";
import {
  Form,
  Button,
  Row,
  Col,
  Card,
  Breadcrumb,
  Select,
  Divider,
  Input,
  Typography,
  Space,
} from "antd";
import { Link, useParams } from "react-router-dom";
import { PlusOutlined } from "@ant-design/icons";
import {
  getAllInvoices,
  deleteInvoiceRecord,
} from "../addInvoice/AddInvoiceSlice";
import { useSelector, useDispatch } from "react-redux";

export function ViewInvoices() {
  const dispatch = useDispatch();
  const { Title } = Typography;
  const data = useSelector((state) => state.addInvoice.invoiceRecords);

  useEffect(() => {
    dispatch(getAllInvoices());
  }, [dispatch]);

  const [form] = Form.useForm();

  const onSubmit = (values) => {
    console.log(values);
  };

  const deleteProject = (e) => {
    dispatch(deleteInvoiceRecord(e.invoiceId));
  };

  return (
    <>
      <Row className="titlt-part" align="middle">
        <Col xs={24} md={8}>
          <Title level={4}>View Invoice</Title>
        </Col>
        <Col xs={24} md={16} className="text-right">
          <Space>
            <Breadcrumb>
              <Breadcrumb.Item href="/DashBoard">
                <span>Home</span>
              </Breadcrumb.Item>
              <Breadcrumb.Item>Invoice</Breadcrumb.Item>

              <Breadcrumb.Item>View Invoice</Breadcrumb.Item>
            </Breadcrumb>
            <Link to="/invoice/addinvoice">
              <Button
                justify="end"
                type="primary"
                icon={<PlusOutlined />}
                style={{ marginLeft: "auto" }}
              >
                Add Invoice
              </Button>
            </Link>
          </Space>
        </Col>
      </Row>
      <Form
        layout="vertical"
        onFinish={onSubmit}
        form={form}
        className="mt-10px"
        initialValues={{
          remember: true,
        }}
      >
        <Row gutter={16}>
          <Col xs={24} md={8} lg={8}>
            <Form.Item
              label="Financial Year"
              name="FinancialYear"
              rules={[
                {
                  required: true,
                  message: "Please select your Project Type",
                },
              ]}
            >
              <Select
                showSearch
                name="FinancialYear"
                placeholder="Select Financial Year"
                optionFilterProp="children"
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
              >
                {/* {projectTypeData.map((d) => (
              <Option key={d.id}>{d.projecttype}</Option>
            ))} */}
              </Select>
            </Form.Item>
          </Col>
          <Col xs={24} md={8} lg={8}>
            <Form.Item
              label="Month"
              name="Month"
              rules={[
                {
                  required: true,
                  message: "Please select your Project Type",
                },
              ]}
            >
              <Select
                showSearch
                name="Month"
                placeholder="Select Month"
                optionFilterProp="children"
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
              >
                {/* {projectTypeData.map((d) => (
              <Option key={d.id}>{d.projecttype}</Option>
            ))} */}
              </Select>
            </Form.Item>
          </Col>
          <Col xs={24} md={8} lg={8}>
            <Button type="primary" style={{ marginLeft: "auto", top: "30px" }}>
              Search
            </Button>
          </Col>
        </Row>
        <Divider />
        <div style={{ float: "right" }}>
          <Col span={24} xs={48} md={48} lg={48}>
            <Form.Item>
              <Input name="search" placeholder="Search Here" />
            </Form.Item>
          </Col>
        </div>
        <ViewTable datasource={data} delete={deleteProject} />
      </Form>
    </>
  );
}
